<script>
import { sync } from 'vuex-pathify'

export default {
	props: {
		transparent: Boolean,
		dense: Boolean,
		hideIcon: Boolean,
		iconType: String,
		icon: String,
		iconHtml: String,
		iconImage: [Object, String],
		text: String,
	},
	computed: {
		brandsDialog: sync('shop/brandsDialog'),
	},
}
</script>

<template>
	<AppBar-Button
		class="appbar-menu-items primary"
		@click="brandsDialog = true"
		:transparent="transparent"
		:dense="dense"
		:hide-icon="hideIcon"
		:icon-type="iconType"
		:icon="icon"
		:icon-html="iconHtml"
		:icon-image="iconImage"
		:text="text"
	/>
</template>

